import { styled } from "@linaria/react";

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
